module.exports = __webpack_public_path__ + "img/drug-active.76d68a00.svg";